import { LinkButton, Stack } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { addAislesToColumnDetails, addAislesToRows, addExitRows, isEmptyRow, isExitRow, isRowOverWing } from '../utils/layout';
import ColumnDetails from './rowsandcolums/ColumnDetails';
import Row from './rowsandcolums/Row';
import RowContent from './rowsandcolums/RowContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const generateKey = index => `row_${index}`;
export const keyboardOnlyButtonStyles = css`
  bottom: 20px;
  inset-inline-end: 14%;
  opacity: 0;
  padding: 8px 16px;
  pointer-events: none;
  position: fixed;
  z-index: 9999;

  &:focus-visible {
    opacity: 1;
    pointer-events: auto;
  }

  @media (max-width: 768px) {
    inset-inline: 30%;
  }
`;
const SeatMapCabin = _ref => {
  let {
    activeSegment,
    carrier,
    sellSeatMapColumnDetails = [],
    onChange,
    rows = [],
    seatTravelers,
    travelerSeatSelectionsBySegment,
    onClose,
    onSaveAndContinue,
    shouldShowSummary
  } = _ref;
  const {
    t
  } = useTranslation();
  const columnsWithAisles = addAislesToColumnDetails(sellSeatMapColumnDetails);
  const rowsWithAisles = addAislesToRows(rows, columnsWithAisles);
  const transformedRowData = addExitRows(rowsWithAisles);
  const handleSkipToNextSegment = e => {
    if (!shouldShowSummary) {
      onSaveAndContinue(e);
      return;
    }
    onClose(travelerSeatSelectionsBySegment);
  };
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 0,
    children: [/*#__PURE__*/_jsx(ColumnDetails, {
      details: columnsWithAisles,
      isOverWing: transformedRowData !== null && transformedRowData !== void 0 && transformedRowData[0] ? isRowOverWing(transformedRowData[0]) : false
    }), transformedRowData === null || transformedRowData === void 0 ? void 0 : transformedRowData.map((row, index) => {
      var _row$sellSeatMapSeats, _row$sellSeatMapSeats2;
      const hasExitArrow = (_row$sellSeatMapSeats = (_row$sellSeatMapSeats2 = row.sellSeatMapSeats) === null || _row$sellSeatMapSeats2 === void 0 ? void 0 : _row$sellSeatMapSeats2.some(seat => (seat === null || seat === void 0 ? void 0 : seat.type) === 'EXIT_ARROW')) !== null && _row$sellSeatMapSeats !== void 0 ? _row$sellSeatMapSeats : false;
      const shouldRenderLinkButton = !hasExitArrow;
      return /*#__PURE__*/_jsxs(Row, {
        isEmptyRow: isEmptyRow(row),
        isOverWing: isRowOverWing(row),
        children: [/*#__PURE__*/_jsx(RowContent, {
          activeSegment: activeSegment,
          carrier: carrier,
          isEmptyRow: isEmptyRow(row),
          isExitRow: isExitRow(row),
          onChange: onChange,
          seatTravelers: seatTravelers,
          sellSeatMapSeats: row.sellSeatMapSeats
        }), shouldRenderLinkButton && /*#__PURE__*/_jsx(LinkButton, {
          className: keyboardOnlyButtonStyles,
          "data-testid": "accessibilitySkipToNextSegment",
          onClick: handleSkipToNextSegment,
          children: t('Product.SeatMap.Accessibility.SkipToNextSegment.Text')
        })]
      }, generateKey(index));
    })]
  });
};
export default SeatMapCabin;
//# sourceMappingURL=SeatMapCabin.js.map